// @flow
import TextArea from "../GUI_COMMON/COMPONENTS/TextArea";
import React from "react";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";

interface NotesEditorProps {
    name : string;
    value: string;
    rows: number;
    tabIndex: number;
    onChange : () => void;
    readOnly? : boolean;
    showAddButton? : boolean;
    onAddNoteClicked?: () => void;
}

const NotesEditor: React.FC<NotesEditorProps> = ({name, value, rows, 
                                                     tabIndex, onChange, readOnly, showAddButton,
                                                    onAddNoteClicked}) => {
    
    return (
        <div className="d-flex justify-content-between">
            <div className="w-100">
             <TextArea label="Notes" name={name} onChange={onChange} placeholder=""  maxLength={512}
                      value={value} rows={rows} tabIndex={tabIndex} readonly={readOnly}/>
            </div>
            {showAddButton&& 
                <div className="mb-auto mt-5">
                    <LIButton faIcon="fa fa-plus" heightPels={80} primary small tooltip="Add Note" bgClass="ml-1" 
                        onClick={onAddNoteClicked} disabled={!onAddNoteClicked} tabIndex={tabIndex?tabIndex+1 : null}/>
                </div>    
            }
                    
        </div>
    );
}

export default NotesEditor;